import { freeze } from "immer";

export const MyAccountTab = freeze(
  {
    Profile: "profile",
    Team: "team",
    Settings: "settings",
    Billing: "billing",
  } as const,
  true,
);
